import React from 'react';
import { useOffline } from '../context/OfflineContext';
import { WifiOff, RefreshCw, CloudOff } from 'lucide-react';
import { Button } from './ui/button';

export const OfflineIndicator = () => {
    const { isOnline, pendingCount, syncing, syncPendingData } = useOffline();

    if (isOnline && pendingCount === 0) {
        return null;
    }

    return (
        <div className={`fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-auto z-50 animate-fade-in`}>
            <div className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg ${
                isOnline ? 'bg-amber-50 border border-amber-200' : 'bg-red-50 border border-red-200'
            }`}>
                {!isOnline ? (
                    <>
                        <WifiOff className="h-5 w-5 text-red-600" />
                        <div className="flex-1">
                            <p className="font-medium text-red-800">Offline-Modus</p>
                            <p className="text-sm text-red-600">
                                {pendingCount > 0 
                                    ? `${pendingCount} Änderung${pendingCount > 1 ? 'en' : ''} wird synchronisiert`
                                    : 'Änderungen werden lokal gespeichert'
                                }
                            </p>
                        </div>
                        <CloudOff className="h-5 w-5 text-red-400" />
                    </>
                ) : (
                    <>
                        <RefreshCw className={`h-5 w-5 text-amber-600 ${syncing ? 'animate-spin' : ''}`} />
                        <div className="flex-1">
                            <p className="font-medium text-amber-800">Synchronisierung ausstehend</p>
                            <p className="text-sm text-amber-600">
                                {pendingCount} Änderung{pendingCount > 1 ? 'en' : ''} wird synchronisiert
                            </p>
                        </div>
                        <Button 
                            size="sm" 
                            variant="outline"
                            onClick={syncPendingData}
                            disabled={syncing}
                            className="border-amber-300 text-amber-700 hover:bg-amber-100"
                        >
                            Jetzt sync
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default OfflineIndicator;
